export interface UpdatePersonalInformationDto {
  firstName?: string;
  lastName?: string;
  fatherName?: string;
  nationalId?: string;
  certificateNo?: string;
  birthDate?: number;
  isMale?: boolean;
  nationalCardFileUrl?: string;
}

export function toUpdatePersonalInformationFormData(
  dto: UpdatePersonalInformationDto,
): FormData {
  const formData = new FormData();

  if (dto.firstName !== undefined) {
    formData.append('FirstName', dto.firstName);
  }

  if (dto.lastName !== undefined) {
    formData.append('LastName', dto.lastName);
  }

  if (dto.fatherName !== undefined) {
    formData.append('FatherName', dto.fatherName);
  }

  if (dto.nationalId !== undefined) {
    formData.append('NationalId', dto.nationalId);
  }

  if (dto.certificateNo !== undefined) {
    formData.append('CertificateNo', dto.certificateNo);
  }

  if (dto.birthDate !== undefined) {
    formData.append('BirthDate', String(dto.birthDate));
  }

  if (dto.isMale !== undefined) {
    formData.append('IsMale', String(dto.isMale));
  }

  if (dto.nationalCardFileUrl !== undefined) {
    formData.append('NationalCardFileUrl', dto.nationalCardFileUrl);
  }

  return formData;
}
